<template>
  <v-row wrap class="px-4 pt-0 ma-0" no-gutters>
    <template
      v-for="(e, i) in [...Array(months)]"
    >
      <v-col
        v-if="i === 0"
        :key="i"
        cols="3"
        class="text-left pb-2"
      >
        <v-btn icon @click="navPrevMonth">
          <v-icon>fa-arrow-left</v-icon>
        </v-btn>
      </v-col>
      <v-col
        :key="i + '_2'"
        :cols="i === 0 ? 6 : 12"
        class="text-center month-title pb-2"
      >
        <b>{{ monthName(monthFirstDay(i)) }}</b>
      </v-col>
      <v-col
        v-if="i === 0"
        :key="i + '_3'"
        cols="3"
        class="text-right pb-2"
      >
        <v-btn icon @click="navNextMonth">
          <v-icon>fa-arrow-right</v-icon>
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        :key="i + '_4'"
        class="pb-3"
      >
      <v-calendar
        :value="monthFirstDay(i)"
        weekdays="1,2,3,4,5,6,0"
        :event-more="false"
        color="primary"
        :locale="$store.state.language"
      >
        <template v-slot:day-label="{ present, hasTime, day, date }">
          <v-row
            class="fill-height"
          >
            <v-sheet
                :style="!bookedDays[date] ? 'background: none !important;' : ''"
                :color="bookedDays[date]
                  ? bookedDays[date] !== newStatusId
                    ? 'red lighten-3'
                    : 'yellow lighten-3'
                  : ''"
                width="100%"
                height="100%"
                tile
              >
              {{ day }}
              </v-sheet>
          </v-row>
        </template>
      </v-calendar>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import moment from 'moment'

export default {
  name: 'CalendarMonthsPreview',

  data () {
    return {
      startMonth: moment().format('MM'),
      startYear: moment().format('YYYY'),
      newStatusId: '5bebc64446853c27bcfe3dc7',
      // colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1']
    }
  },

  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    },

    fields: {
      type: Array,
      default: () => {
        return []
      }
    },

    topOffset: {
      type: Number,
      default: 0
    }
  },

  computed: {
    months () {
      const appHeaders = 80
      let height = this.$store.state.innerHeight - appHeaders - this.topOffset
      if (this.$vuetify.breakpoint.smAndDown) {
        height -= 36
      }
      return Math.floor(height / 237) || 1
    },

    events () {
      let color = this.getNextColor()
      let events = this.items.filter(item => item.dateStart && item.dateEnd)
        .map(item => {
          const event = {
            name: item.customerName,
            start: moment(item.dateStart).format('YYYY-MM-DD'),
            end: moment(item.dateEnd).format('YYYY-MM-DD'),
            color: color
          }
          color = this.getNextColor(color)
          return event
        })
      return events
    },

    bookedDays () {
      let bookedDays = {}
      this.items
        .forEach(booking => {
          if (moment(booking.dateStart) <= moment(booking.dateEnd) &&
            // Is not archived nor cancelled
            booking.status &&
            booking.status.id &&
            !['5bebc64f46853c27bcfe3dc9'].includes(booking.status.id.toString())
          ) {
            // console.log('booking.dateStart', booking.dateStart)
            var day = moment(booking.dateStart)
            while (day < moment(booking.dateEnd)) { // add 6 hours to be sure, sometimes causing issues otherwise
              bookedDays[day.format('YYYY-MM-DD')] = booking.status.id.toString()
              // if (['5f003e9ae7e04874aa94945c', '5f003e9ae7e04874aa94945d'].includes(booking.id)) {
              //   console.log('booked:', day.format())
              // }
              day = day.add(1, 'day')
            }
          }
        })
      return bookedDays
    }
  },

  methods: {
    monthName (date) {
      moment.locale(this.$store.state.language)
      return moment(date).format('MMMM YYYY')
    },

    monthFirstDay (i) {
      return moment(this.startYear + '-' + this.startMonth + '-01')
        .add(i, 'months')
        .format('YYYY-MM-DD')
    },

    navPrevMonth () {
      const newDate = moment(this.monthFirstDay(0)).subtract(this.months, 'months')
      this.startMonth = newDate.format('MM')
      this.startYear = newDate.format('YYYY')
    },

    navNextMonth () {
      const newDate = moment(this.monthFirstDay(0)).add(this.months, 'months')
      this.startMonth = newDate.format('MM')
      this.startYear = newDate.format('YYYY')
    }
  }
}
</script>

<style scoped>
.month-title {
  line-height: 36px;
}
</style>
